<template>
  <div class="wrap personal-wrap flex-column">
    <mu-infinite-scroll :loading="loadShow" :loadingText="loadingTip" class="load" v-if="loadShow" />
    <div class="flex-item" v-if="listMemDetailInfo.openId!=null && !loadShow">
      <div class="grid-tip">
        基本信息
      </div>
      <ul>
        <li class="user-order-title headimg"   @click="open('headimg')"> <!---->
          <p>头像
            <span class="right">
             <!--  <div class="user-hear">
                <img :src="listMemDetailInfo.avatarImage && listMemDetailInfo.avatarImage.imagePath">
              </div> -->
              <imgs class="user-hear" :imagePath="listMemDetailInfo.avatarImage && listMemDetailInfo.avatarImage.imagePath"></imgs>
            </span>
          </p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </li>
        <li class="user-order-title" @click="editNickname(listMemDetailInfo.nickName)">
          <p>昵称<span class="right">{{listMemDetailInfo.nickName}}</span></p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </li>
        <li class="user-order-title" @click="open('sex')">
          <p v-if="listMemDetailInfo.sex==1">性别<span class="right">男</span></p>
          <p v-if="listMemDetailInfo.sex==2">性别<span class="right">女</span></p>
          <p v-if="listMemDetailInfo.sex==0">性别<span class="right">保密</span></p>
          <p v-if="listMemDetailInfo.sex==null">性别</p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </li>
        <li class="user-order-title">
          <p>生日<span class="right"><mu-date-picker class="boxDate" hintText="选择生日"   @change="birthDayChange" v-model="valBirthDay" :maxDate="nowTime"/></span></p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </li>
      </ul>
      <iframe name="uploadFrame" id="uploadFrame" style="display:none;"></iframe>
      <mu-popup position="bottom" popupClass="demo-popup-bottom select" :open="headimgPopup" @close="close('headimg')">
        <mu-content-block class="wrap">
          <div class="popupitem">
            <label for="cameraImg">相机</label>
            <input id="cameraImg" type="file" accept="image/*" capture="camera" class="file-upload-button" @change="selimg(1)" ref="cameraImg">
          </div>
          <div class="popupitem">
            <label for="albumImg">从相册选择</label>
            <input id="albumImg" type="file" accept="image/*" class="file-upload-button"  @change="selimg(2)" ref="albumImg" value="">
          </div>
          <div class="popupitem" @click="close('headimg')">取消</div>
        </mu-content-block>
      </mu-popup>
      <mu-popup position="bottom" popupClass="demo-popup-bottom select" :open="sexPopup" @close="close('sex')">
        <mu-content-block class="wrap">
          <div class="popupitem" v-for="(item,index) in sex" @click="selsex(index)">{{item.name}}</div>
          <div class="popupitem" @click="close('sex')">取消</div>
        </mu-content-block>
      </mu-popup>
      <mu-popup position="bottom" popupClass="demo-popup-bottom select" :open="brithPopup" @close="close('brith')">
        <mu-content-block class="wrap">
          <div class="popupitem" @click="close('brith')">取消</div>
        </mu-content-block>
      </mu-popup>
    </div>
    <!-- <menus></menus> -->
    <mu-toast v-if="successMsg" message="修改成功!" class="custom-toast" />
    <mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import { mapActions, mapGetters } from 'vuex';
import util from '@common/utils/util';
import Constant from '@/Constant';
import imgs from '@components/image/image';
export default {
  data() {
    return {
      actionUrl: Constant.uploadBaseUrl + "/apps", //提交URL
      loadShow: true,
      loadingTip:'拼命加载中',
      shooseSex: '', //选择性别
      headimgPopup: false,
      sexPopup: false,
      brithPopup: false,
      sex: [{
        id: 2,
        name: '女'
      }, {
        id: 1,
        name: '男'
      }, {
        id: 0,
        name: '保密'
      }],
      listMemDetailInfo: [], //获取会员详细信息
      successMsg: false, //修改成功
      valBirthDay: '', //出生日期
      nowTime: '',
      toast:{
          isShow:false,
          messageTip:'',
      }
    }
  },
  methods: {
    ...mapActions({
      doSetBirthDay: 'doSetBirthDay', //设置出生日期
      doSetMemImage: 'doSetMemImage', //设置会员头像
      doSetNickName: 'doSetNickName', //设会员昵称
      doSetSex: 'doSetSex', //设置会员性别
      getMemDetailInfo: 'getMemDetailInfo', //获取会员详细信息
      uploadPic:'uploadPic'
    }),
    showTipMessage(isShow,msg){
        this.toast.isShow = isShow;
        this.toast.messageTip =msg;
        setTimeout(() => { 
          this.toast.isShow = false 
        }, 1500);
    },
    open(position) {
      this[position + 'Popup'] = true
    },
    close(position) {
      this[position + 'Popup'] = false
    },
    editNickname(nickName) {
      this.$router.push({
        path: '/main/editnickname?nickName=' + nickName
      })
    },
    //chenge 事件监听日期变化
    birthDayChange(valueDay) {
      var valueDay = new Date(valueDay).getTime();
      this.itDoSetBirthDay(valueDay); //调用方法修改
    },
    //选择生日信息
    selsex(index) {
      this.shooseSex = this.sex[index].id;
      this.itDoSetSex(this.shooseSex); //修改性别   
      this.close('sex');
    },

    // 选择图片
    selimg(action) {
      let filetarget = '';
      if (action == 1) {
        filetarget = this.$refs.cameraImg.files[0];
        // this.imgPreview(this.$refs.cameraImg.files[0]);
      } else if (action == 2) {
        filetarget = this.$refs.albumImg.files[0];
        // this.imgPreview(this.$refs.albumImg.files[0]);
      }
      if(!filetarget){
        return;
      }
      this.loadShow = true; //开始加载
      this.loadingTip = '正在上传头像~'
      util.uploadImg(this.actionUrl,filetarget,'avatar').then(res=>{
        //console.log('page result1',res.returnTargets[0].fileId) 
        if(!res.returnTargets[0].fileId){
          return;
        }
        //this.listMemDetailInfo.avatarImage.imagePath ='/image/'+fileName
        this.itDoSetMemImage(res.returnTargets[0].fileId);
      }).catch(err=>{
          //console.log('page result2',err)
      });   
      this.close('headimg');
    },

   
    // 预览
    imgPreview(file) {
      let self = this;

      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          self.listMemDetailInfo.avatarImage.imagePath = this.result;
          console.log("结果是?>>>",this);
        }
      }
    },
    //设置生日api
    itDoSetBirthDay(birthdayValue) {
      this.doSetBirthDay(birthdayValue).then(res => {
        this.showTipMessage(true,"修改成功！");
        this.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(error => {})
    },
    //设置会员头像api
    itDoSetMemImage(memImageId) {
      this.doSetMemImage(memImageId).then(res => {
        this.showTipMessage(true,"上传成功！");
        this.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(error => {})
    },
    //修改性别
    itDoSetSex(sex) {
      this.doSetSex(sex).then(res => {
        this.showTipMessage(true,"修改成功！");
        this.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(error => {})
    },
    //调去会员详细信息
    getMemDetailInfoList() {
      this.getMemDetailInfo().then(res => {
        this.listMemDetailInfo = res; //获取到的信息
        // this.listMemDetailInfo.avatarImage.imagePath = Constant.imgBaseUrl + '/' + res.avatarImage.imagePath;
        // console.log(">>>>>>>>>>>>>>>",this.listMemDetailInfo.avatarImage.imagePath)
        this.loadShow = false; //关闭加载
        this.nowTime = util.format(new Date(new Date()), 'yyyy-MM-dd'); //当前的时间
        if (this.listMemDetailInfo.birthDay != null) {
          var getDay = parseInt(this.listMemDetailInfo.birthDay, 10); //转换为整型
          this.valBirthDay = util.format(new Date(getDay), 'yyyy-MM-dd'); //展示的时间
        } else if (this.listMemDetailInfo.birthDay == null) {
          this.valBirthDay = ''; //当前的时间
          return;
        }
      }).catch(error => {})
    },

  },
  created() {
    //获取会员详细信息
    this.getMemDetailInfoList();
    //this.itDoSetMemImage(); //设置头像
  },
  components: {
    menus,
    imgs
  },
  computed:{
    imgPath(){
      if(this.imagePath){
        return Constant.imgBaseUrl + '/' + src;
      }else {
        return this.defaultPath;
      }
    }
  },
  watch: {},
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.file-upload-button {
  font-size: 10px;
  opacity: 0;
  height: 1.2rem;
  width: 100%;
  display: block;
}

.popupitem {
  label {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}


/*.mu-date-display {
  background-color: #ec5555;
  background: linear-gradient(to right, #ec5555, #ec552E);
}

.mu-day-button-bg {
  background-color: #ec5555;
}

.mu-day-button.now .mu-day-button-text {
  color: #ec5555;
}

.mu-calendar-actions .mu-flat-button-label {
  color: #ec5555;
}

.mu-year-button.selected .mu-year-button-text {
  color: #ec5555;
}

.mu-day-button.now .mu-day-button-text {
  color: #000;
}*/

</style>



// WEBPACK FOOTER //
// userinfo.vue?231168cc